export default class LocalStorage {
  public static set Hotel3Pid(value: string) {
    localStorage.setItem('hotel3pid', value)
  }
  public static get Hotel3Pid(): string {
    return localStorage.getItem('hotel3pid')
  }

  public static set ReservationUuId(value: string) {
    localStorage.setItem('ruid', value)
  }
  public static get ReservationUuId(): string {
    return localStorage.getItem('ruid')
  }

  
   public static get IsTabletMode(): boolean {
    return localStorage.getItem("ist") == "Y" ? true : false
  }

  public static set IsTabletMode( tabletMode: boolean) {
    localStorage.setItem("ist",tabletMode ? "Y" : "N" )
  }


  public static set TabletToken(value: string) {
    localStorage.setItem('tbtk', value)
  }
  public static get TabletToken(): string {
    return localStorage.getItem('tbtk')
  }

  public static set Group3Pid(value: string) {
    localStorage.setItem('g3pi', value)
  }
  public static get Group3Pid(): string {
    return localStorage.getItem('g3pi')
  }


  
  public static set OperationMode(value: string) {
    localStorage.setItem('opm', value)
  }
  public static get OperationMode(): string {
    return localStorage.getItem('opm')
  }

  public static get IsVipTabletMode(): boolean {
    return LocalStorage.IsTabletMode && LocalStorage.OperationMode == 'VIP'
  }


 public static set Device3PId(value: string) {
    localStorage.setItem('deviceId', value)
  }
  public static get Device3PId(): string {
    return localStorage.getItem('deviceId')
  }







} 